import { SxProps, Theme } from '@mui/system';

const styles = {
  approved: {
    color: 'eventChip.postedText',
    backgroundColor: 'eventChip.posted',
  },
  rejected: {
    backgroundColor: 'eventChip.booked',
    color: 'eventChip.bookedText',
  },
  pending: {
    backgroundColor: 'eventChip.requested',
    color: 'eventChip.requestedText',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
